import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ReceiptApi, checkDuplicateReceiptCodeOption } from 'api';

export const createReceipt = createAsyncThunk(
  'receipt/createReceipt',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.create(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateReceiptCode = createAsyncThunk(
  'receipt/generateReceiptCode',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.generateCode(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateReceiptCode = createAsyncThunk(
  'receipt/checkDuplicateReceiptCode',
  async (option: checkDuplicateReceiptCodeOption, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.checkDuplicateCode(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneForUpdate = createAsyncThunk(
  'receipt/findOneForUpdate',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.findOneForUpdate(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateReceipt = createAsyncThunk(
  'receipt/updateReceipt',
  async (option: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.update(option.id, option.body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerReceipts = createAsyncThunk(
  'receipt/findCustomerReceipts',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.findCustomerReceipt(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findSupplierPayments = createAsyncThunk(
  'receipt/findSupplierPayments',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.findSupplierPayment(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCollectDebt = createAsyncThunk(
  'receipt/createCollectDebt',
  async (option: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.createCollectDebt(
        option.id,
        option.body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomerCollectDebt = createAsyncThunk(
  'receipt/createCustomerCollectDebt',
  async (option: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.createCustomerCollectDebt(
        option.id,
        option.body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomerCollectDebtByCollaborator = createAsyncThunk(
  'receipt/createCustomerCollectDebtByCollaborator',
  async (option: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.createCustomerCollectDebtByCollaborator(
        option.id,
        option.body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteReceipt = createAsyncThunk(
  'receipt/deleteReceipt',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ReceiptApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: IState = {
  list: [],
  reloadFlag: false,
};

const receiptSlice = createSlice({
  name: 'receipt',
  initialState,
  reducers: {
    reloadReceipt(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: receiptReducer } = receiptSlice;

export const { reloadReceipt } = actions;

export default receiptReducer;
